<template>
  <v-container>
    <v-alert
      type="error"
      transition="scale-transition"
      v-model="alert"
      border="left"
      dismissible
    >{{alertMsg}}</v-alert>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="name"
            :rules="[rules.required, rules.min, rules.max]"
            :label="$t('DataHome.name')"
            hint="Between 3 and 30 characters"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-text-field v-model="networkId" :label="$t('DataHome.networkId')" readonly required></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-select
            :label="$t('DataHome.deviceTypeId')"
            :rules="[rules.required]"
            :items="deviceTypes"
            v-model="deviceType"
            required
            item-value="deviceTypeId"
            item-text="deviceTypeId"
            return-object
          >
            <template slot="selection" slot-scope="{ item }">{{ item.deviceTypeId }}</template>
            <template slot="item" slot-scope="{ item }">
              <v-list-item-content>
                <div class="subtitle-2 mb-4 text-uppercase">{{item.deviceTypeId}}</div>
                <v-list-item-title class="headline mb-1">{{item.name}}</v-list-item-title>
                <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                <v-system-bar color="transparent">
                  <v-spacer></v-spacer>
                  <v-chip
                    v-for="scope in item.scopes"
                    :key="scope"
                    class="mt-2 ml-1 mb-1"
                    :color="scopeColor(scope)"
                    text-color="white"
                    small
                  >{{scope}}</v-chip>
                </v-system-bar>
              </v-list-item-content>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DataHome.back')}}
        </v-btn>
        <v-btn class="ma-2" tile outlined color="primary" @click="registerDevice">
          <v-icon left>mdi-plus-circle</v-icon>
          {{$t('DataHome.create')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {},
  props: {
    networkId: String
  },
  data() {
    return {
      name: "",
      deviceType: null,
      deviceTypes: [],
      valid: false,
      alert: false,
      alertMsg: "",
      rules: {
        required: value => !!value || this.$t("DeviceTypes.rules.required"),
        min: v => v.length >= 3 || this.$t("DeviceTypes.rules.min"),
        max: v => v.length <= 30 || this.$t("DeviceTypes.rules.max")
      }
    };
  },
  computed: {},
  methods: {
    scopeColor: function(scope) {
      switch (scope) {
        default:
          return "primary";

        case "admin":
          return "red";

        case "creator":
          return "#981b00";
      }
    },
    registerDevice: function() {
      if (this.valid) {
        axios
          .post(
            process.env.VUE_APP_API_ADDR + "/api/device",
            {
              name: this.name,
              networkId: this.networkId,
              deviceTypeId: this.deviceType.deviceTypeId
            },
            {
              headers: { Authorization: tokenStore.getToken() }
            }
          )
          .then(res => {
            if (res.data.success) {
              this.$emit("save");
            }
          })
          .catch(err => {
            console.log(err.response);
          });
      } else {
        //
        console.log("la");
        this.alert = true;
        this.alertMsg = this.$t("DataHome.form-error");
      }
    }
  },
  beforeMount: function() {
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() }
      })
      .then(res => {
        if (res.data.user.permissions.deviceTypes.length == 0) {
          this.noDeviceType = true;
        } else {
          this.noDeviceType = false;

          let $deviceTypes = res.data.user.permissions.deviceTypes;
          $deviceTypes.forEach(deviceType => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/devicetype/" +
                  deviceType.deviceTypeId,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                deviceType.name = res.data.deviceType.name;
                deviceType.description = res.data.deviceType.description;
                deviceType.properties = res.data.deviceType.properties;
                this.deviceTypes.push(deviceType);
              })

              .catch(err => {
                console.log(err);
              });
          });
        }
        this.ready = true;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>